import React from 'react';
import PropTypes from 'prop-types';
import phone from '../../../../../../../images/phone.svg';
import { t } from '../../../../../../modules/infra/i18n';

const MobileTooltip = ({ children }) => (
  <span className="c-info-tooltip-new-handler">
    <div className="c-info-tooltip-new__content">
      {t('customers:duplicates.mobile_tooltip_message')}
      {' '}
      {t('customers:duplicates.mobile_tooltip_assistance')}
    </div>
    <img src={phone} style={{ width: '15px' }} alt={t('customers:duplicates.mobile_alt_text')} />
    {children}
  </span>
);

MobileTooltip.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MobileTooltip;
